import { render, staticRenderFns } from "./SimpleDonut.vue?vue&type=template&id=6253c928&scoped=true&"
import script from "./SimpleDonut.vue?vue&type=script&lang=js&"
export * from "./SimpleDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6253c928",
  null
  
)

export default component.exports